import React from 'react';
import './FBTextArea.css';

export const FBTextArea = props => {
  return <textarea className="fb_text_area" {...props} />;
};

export default FBTextArea;
